export const company = {
  name: "文趣互动（海南）科技有限责任公司",
  shortName: "文趣互动",
  englishName: "Elitestar Interactive Hainan Tech Co. LTD",
  slogan: "与世界 · 趣未来",
  founded: "2024-10-16",
  creditCode: "91460000MAE2G7BR10",
  capital: "100万元人民币",
  status: "存续",
  type: "有限责任公司（非自然人投资或控股的法人独资）",
  industry: "软件和信息技术服务业",
  legalRep: "邓骁",
  parent: "成都文趣星球科技有限公司",
  group: "开普云",
  address: "海南省三亚市吉阳区榆亚路797号高德体育大厦1楼101房1层053号",
  email: "wqxq-guang@ucap.com.cn",
  mapUrl:
    "https://uri.amap.com/search?keyword=%E6%B5%B7%E5%8D%97%E7%9C%81%E4%B8%89%E4%BA%9A%E5%B8%82%E5%90%89%E9%98%B3%E5%8C%BA%E6%A6%86%E4%BA%9A%E8%B7%AF797%E5%8F%B7%E9%AB%98%E5%BE%B7%E4%BD%93%E8%82%B2%E5%A4%A7%E5%8E%A6",
  productSite: "https://www.iwqxq.com",
};

export const navItems = [
  {
    label: "关于我们",
    path: "/about-us",
    children: [
      { label: "公司简介", path: "/about-us", tab: "tab1" },
      { label: "文化及价值观", path: "/about-us", tab: "tab2" },
      { label: "股东背景", path: "/about-us", tab: "tab3" },
      { label: "管理团队", path: "/about-us", tab: "tab4" },
      { label: "大事记", path: "/about-us", tab: "tab5" },
    ],
  },
  {
    label: "产品",
    path: "/product",
    children: [
      { label: "文趣书坊", path: "/product", tab: "tab1" },
      { label: "趣里活", path: "/product", tab: "tab2" },
      { label: "趣IP", path: "/product", tab: "tab3" },
      { label: "AIGC", path: "/product", tab: "tab4" },
    ],
  },
  {
    label: "新闻动态",
    path: "/news",
    children: [
      { label: "企业动态", path: "/news", tab: "tab1" },
      { label: "行业新闻", path: "/news", tab: "tab2" },
    ],
  },
  { label: "合作伙伴", path: "/partner" },
  {
    label: "加入我们",
    path: "/jobIndex",
    children: [
      { label: "校园招聘", path: "/job", tab: "campus" },
      { label: "社会招聘", path: "/job", tab: "social" },
    ],
  },
];

export const aboutIntro = [
  "文趣互动（海南）科技有限责任公司成立于 2024 年 10 月 16 日，注册于海南省三亚市，是成都文趣星球科技有限公司的全资子公司，开普云集团成员企业。公司扎根海南自由贸易港，面向三亚及全岛文旅场景，专注文化、文旅、文娱元宇宙应用场景的建设与运营，通过构建线上线下虚实融合的解决方案，实现长期可持续的商业价值。",
  "母公司成都文趣星球科技有限公司由开普云信息科技股份有限公司（证券代码：688228.SH）、成都博瑞传播股份有限公司（证券代码：600880.SH）、成都文化产权交易所有限公司等合资设立。文趣互动承接集团在文化元宇宙领域的产品能力与技术底座，围绕人工智能、XR、数字孪生与区块链等技术，为政府、景区与企业提供数字化转型升级方案，为用户提供沉浸式互动与消费体验。",
  "公司目前聚焦元宇宙+文化、元宇宙+文旅、元宇宙+文娱等应用方向，依托海南自贸港政策优势与三亚国际旅游消费中心定位，推动中国文化属性元宇宙在滨海目的地落地，助力中华文化破圈出海。",
];

export const cultureCards = [
  { title: "定 位", content: "多模态元宇宙聚合平台研运商" },
  { title: "愿 景", content: "全球多模态元宇宙领军者" },
  { title: "使 命", content: "虚实相生，万物链接" },
  { title: "价 值 观", content: "守正用奇，开放包容，融合创新" },
];

export const shareholders = [
  {
    name: "成都文趣星球科技有限公司",
    role: "全资股东",
    stake: "100%",
    desc: "文趣互动的直接控股股东，专注文化、文旅、文娱元宇宙应用场景建设与运营。",
  },
  {
    name: "开普云信息科技股份有限公司",
    role: "集团背景",
    code: "688228.SH",
    desc: "科创板上市公司，数字政府与数字文化领域核心技术提供方，文趣星球重要股东。",
  },
  {
    name: "成都博瑞传播股份有限公司",
    role: "集团背景",
    code: "600880.SH",
    desc: "A 股主板上市公司，成都传媒集团旗下文化传媒平台，文趣星球单一最大股东。",
  },
  {
    name: "成都文化产权交易所有限公司",
    role: "集团背景",
    desc: "文化产权交易与数字文创基础设施平台，参与投资设立文趣星球。",
  },
];

export const teamText = [
  "公司注册于海南三亚，核心能力承接自母公司文趣星球。文趣星球总部位于成都，核心团队来自 A 股主板上市公司、搜狐、小米、瑞士银行、牛津大学等知名企业与高校，响应国家元宇宙产业发展政策，积极打造新经济增长点，提升品牌影响力和竞争力。",
  "文趣互动以数字化赋能海南文旅实体发展，打造自贸港数字经济标杆；以科技创新筑牢企业发展之根，推进元宇宙相关技术在滨海景区、博物馆、度假区等场景的研发与落地；持续发挥企业优势助力文化发展，推动中国文化属性元宇宙走向世界。",
];

export const timeline = [
  {
    date: "2023-02",
    title: "母公司文趣星球成立",
    content: "成都文趣星球科技有限公司完成工商注册，由博瑞传播、开普云、成都文交所等共同投资设立。",
  },
  {
    date: "2023-06-14",
    title: "携手三体宇宙",
    content: "文趣星球与三体宇宙签署合作协议，联手推出三体「宇宙闪烁」增强现实观测站项目。",
  },
  {
    date: "2023-09-08",
    title: "与腾讯云战略合作",
    content: "在腾讯全球数字生态大会上，文趣星球与腾讯云签署数字生态战略合作，共探数字文旅新前景。",
  },
  {
    date: "2023-09-20",
    title: "三大产品正式发布",
    content: "文趣星球上线并发布数字书坊、趣里活、趣IP 三大元宇宙产品。",
  },
  {
    date: "2024-10-16",
    title: "文趣互动（海南）成立",
    content: "文趣互动（海南）科技有限责任公司在三亚注册成立，成为文趣星球落地海南自贸港的全资子公司。",
  },
];

export const scenes = [
  { name: "学圃堂", pinyin: "XUEPUTANG", tone: "garden" },
  { name: "现代广场", pinyin: "XIANDAIGUANGCHANG", tone: "plaza" },
  { name: "大V书房", pinyin: "DAVSHUFANG", tone: "study" },
  { name: "魁星阁", pinyin: "KUIXINGGE", tone: "pavilion" },
  { name: "图书馆", pinyin: "TUSHUGUAN", tone: "library" },
  { name: "鸿砚斋", pinyin: "HONGYANZHAI", tone: "ink" },
];

export const products = [
  {
    id: "shufang",
    tab: "tab1",
    name: "文趣书坊",
    subtitle: "中国首款全民沉浸式阅读平台",
    summary: "以数字分身与数字空间为基础，为每个家庭打造会成长的书房。",
    body: "文趣互动以「文趣书坊」为主线，致力于创造全球领先的文化元宇宙聚合平台。产品通过创建数字分身、打造数字书房和文娱场景等形式，为用户开启一个平行世界的数智人生，为每个家庭打造专属的「会成长的书房」。产品以数字分身和数字空间为基础，以开放聚合为理念，以数智化、场景化、互动化的方式打造一个全球领先、虚实结合的文化元宇宙世界。同时，通过推动人工智能、区块链、XR 和数字孪生等元宇宙关键技术融合创新，支撑文化元宇宙底座的发展，与广大优质内容创作者一起共建繁荣、生动、有趣的内容生态。",
  },
  {
    id: "qulihuo",
    tab: "tab2",
    name: "趣里活",
    subtitle: "中国首款休闲随行类 XR 趣味探索元宇宙",
    summary: "连接线下流量与线上消费，覆盖食住行游购娱。",
    body: "趣里活是一款休闲随行类 XR 趣味探索元宇宙应用，面向大众以虚实结合的创新方式，切入旅游出行、兴趣出行、休闲出行市场。产品汇聚线下流量，通过 LBS 位置服务、XR 扩展现实、人工智能、区块链、数字孪生等技术，为用户带来虚拟世界与线下实体空间的无缝转换，引导用户边游玩边消费，从食、住、行、游、购、娱六方面提供新的生活休闲出行方式，以数字化方式打造线上线下虚实结合的可持续数字经济体系。扎根三亚，趣里活可服务海南全岛景区、度假区和城市休闲场景。",
  },
  {
    id: "quip",
    tab: "tab3",
    name: "趣IP",
    subtitle: "以多模态元宇宙技术底座打造 IP 应用新场景",
    summary: "让顶级文化 IP 以增强现实方式走进城市与景区。",
    body: "趣IP 以多模态元宇宙技术底座打造 IP 应用新场景。代表项目三体「宇宙闪烁」增强现实观测站，由《三体》三部曲内容开发及商业衍生全球版权方三体宇宙授权。项目以「宇宙闪烁」「幽灵倒计时」等原著场景为核心，呈现城市 AR 场景、裸眼 3D 大屏与线下观测站场馆，计划在多个核心城市巡展。文趣互动将在海南文旅目的地探索更多文化 IP 的沉浸式落地。",
  },
  {
    "id": "niuzailai",
    "tab": "tab4",
    "name": "牛再来",
    "subtitle": "AIGC多模态IP动画短剧，打造元宇宙IP新叙事",
    "summary": "依托AI视频生成能力，孵化原创IP动画内容，拓展线上播放与线下沉浸式场景。",
    "body": "牛再来项目基于多模态元宇宙技术底座，落地AIGC原创IP动画短剧。项目以AI视频生产为核心，完成系列动画内容制作，支持线上视频分发，同时探索AR互动、裸眼3D、线下展陈等多元落地形态。首期《牛再来第一集》AI动画已完成制作，后续将持续更新系列剧集，并联动文旅场景实现IP线上线下联动传播，探索AI原生IP商业化新路径。"
  }
  
];

export const enterpriseNews = [
  {
    id: "hainan-founding",
    title: "文趣互动（海南）科技有限责任公司在三亚注册成立",
    content: "2024 年 10 月 16 日，文趣星球全资子公司文趣互动落户海南三亚，承接集团文化元宇宙能力，服务自贸港数字文旅。",
    date: "2024-10-16",
    category: "enterprise",
    tone: "ocean",
  },
  {
    id: "product-launch",
    title: "文趣星球上线暨元宇宙产品发布，数字书坊等三大产品亮相",
    content: "2023 年 9 月 20 日，母公司文趣星球正式上线，发布数字书坊、趣里活、趣IP 三大产品，为大众从线下实体空间进入虚拟世界搭建桥梁。",
    date: "2023-09-20",
    category: "enterprise",
    tone: "launch",
    source: "证券时报",
  },
  {
    id: "tencent-cloud",
    title: "文趣星球与腾讯云达成战略合作，共探数字文旅新前景",
    content: "在 2023 腾讯全球数字生态大会智慧文旅专场，文趣星球与腾讯云签署数字生态战略合作，面向智慧景区、博物馆、展览展陈等场景共建沉浸式文旅体验。",
    date: "2023-09-08",
    category: "enterprise",
    tone: "cloud",
  },
  {
    id: "three-body",
    title: "文趣星球携手三体宇宙，推出顶级科幻 IP 增强现实超大规模巡展",
    content: "2023 年 6 月 14 日，文趣星球与三体宇宙签署合作协议，双方将联手推出三体「宇宙闪烁」增强现实观测站项目。",
    date: "2023-06-14",
    category: "enterprise",
    tone: "cosmos",
    source: "红星新闻",
  },
  {
    id: "east-suburb",
    title: "科幻顶流登陆成都传媒集团东郊记忆",
    content: "三体「宇宙闪烁」增强现实观测站在成都东郊记忆落地开馆，呈现城市 AR 场景、裸眼 3D 大屏与线下观测站场馆体验。",
    date: "2023-09-30",
    category: "enterprise",
    tone: "exhibit",
  },
];

export const industryNews = [
  {
    id: "hainan-digital-culture",
    title: "海南持续推动数字创意产业与旅文行业融合发展",
    content: "海南将打造 AI 文物数据库、元宇宙博物馆等重点项目，鼓励企业建设文旅元宇宙、虚拟景区与沉浸式街区等新业态。",
    date: "2025-06-27",
    category: "industry",
    tone: "policy",
  },
  {
    id: "sanya-digital-tourism",
    title: "三亚成立数字文旅创新协会，推动智慧导览与景区数字化",
    content: "协会整合大数据、VR/AR、人工智能等技术资源，服务三亚旅游服务质量提升与城市文旅品牌建设。",
    date: "2025-05-19",
    category: "industry",
    tone: "city",
  },
  {
    id: "sanya-ai-resort",
    title: "国内首个 AI 主题度假区项目落户三亚海棠湾",
    content: "复星旅文超级地中海项目以 AI+文旅为核心，探索数字人管家、智能酒店等未来度假体验，为海南文旅数字化提供新样本。",
    date: "2025-04-14",
    category: "industry",
    tone: "resort",
  },
];

export const announcements = [
  {
    date: "2024-10-16",
    title: "文趣互动（海南）科技有限责任公司正式成立",
  },
  {
    date: "2023-09-20",
    title: "集团三大元宇宙产品「文趣书坊」「趣里活」「趣IP」发布",
  },
  {
    date: "2023-09-08",
    title: "集团与腾讯云达成数字文旅战略合作",
  },
];

export const partners = [
  { name: "开普云", en: "UCAP" },
  { name: "博瑞传播", en: "BORI" },
  { name: "成都文交所", en: "CCEE" },
  { name: "腾讯云", en: "Tencent Cloud" },
  { name: "三体宇宙", en: "Three-Body" },
  { name: "成都时代出版社", en: "Times Press" },
  { name: "西南财经大学", en: "SWUFE" },
];

export const newsById = [...enterpriseNews, ...industryNews].reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {});
